module.exports = __webpack_public_path__ + "static/media/ve-logo-only.64f0db1d.png";